import common from './fr/common.json';
import mce from './fr/mce.json';
import schedule from './fr/schedule.json';

// Ressources de traduction embarquées dans le bundle JS.
// Les fichiers JS sont hashés par Vite → pas de problème de cache navigateur/CDN
// comme avec l'ancien chargement HTTP depuis public/locales.
export const RESOURCES = {
  fr: {
    common,
    mce,
    schedule
  }
} as const;

export type Resources = typeof RESOURCES;
